jQuery(($) => {

    if ($('.m-providers-search-menu')[0]) {
        var form   = $('.m-providers-search-menu__form'),
            select = form.find('select');

        select.change(function() {
            form.submit();
        });
    }
});